import { render } from "./ShopConfirmStep.vue?vue&type=template&id=302883d6&scoped=true"
import script from "./ShopConfirmStep.vue?vue&type=script&lang=ts"
export * from "./ShopConfirmStep.vue?vue&type=script&lang=ts"

import "./ShopConfirmStep.vue?vue&type=style&index=0&id=302883d6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-302883d6"

export default script